import { Timezone, Weekday } from './apilibrary/types/common'
import { StudioMetadata } from './apilibrary/types/studio'
import { UserProfileModel } from './apilibrary/types/user'

export interface ComponentWithChildren {
  children: React.ReactNode
}

export const TIMEZONE_LABEL: Record<Timezone, string> = {
  [Timezone.NEW_YORK]: 'New York',
  [Timezone.CHICAGO]: 'Chicago',
  [Timezone.DENVER]: 'Denver',
  [Timezone.LOS_ANGELES]: 'Los Angeles'
}

export const DAY_OF_WEEK_ARRAY = [
  Weekday.MONDAY,
  Weekday.TUESDAY,
  Weekday.WEDNESDAY,
  Weekday.THURSDAY,
  Weekday.FRIDAY,
  Weekday.SATURDAY,
  Weekday.SUNDAY
]

export interface UserProfileWithPictureUrl extends UserProfileModel {
  profilePictureUrl?: string
}

export interface StudioMetadataWithPictureUrl extends Omit<StudioMetadata, 'coverPicture'> {
  coverPictureUrl: string
}
